import { render, staticRenderFns } from "./ImageSwiperPreview.vue?vue&type=template&id=23ad07f3&scoped=true&"
import script from "./ImageSwiperPreview.vue?vue&type=script&lang=js&"
export * from "./ImageSwiperPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImageSwiperPreview.vue?vue&type=style&index=0&id=23ad07f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad07f3",
  null
  
)

export default component.exports